<input type="file" #file style="display: none" (change)="onFilesAdded()" multiple/>
<div class="container" fxLayout="column" fxLayoutAlign="space-evenly stretch">
    <h1 mat-dialog-title>{{dialogTitle}}</h1>
    <div *ngIf="importMode == 'upload'">
        <button [disabled]="uploading || uploadSuccessful || files.size > 0" mat-raised-button color="primary"
                class="add-files-btn" (click)="addFiles()">
            Add File
        </button>
    </div>

    <!-- This is the content of the dialog, containing a list of the files to upload -->
    <mat-dialog-content fxFlex>
        <mat-list *ngIf="importMode == 'upload'">
            <mat-list-item *ngFor="let file of files">

                <h4 mat-line>{{file.name}}</h4>

                <mat-progress-bar *ngIf="progress" mode="determinate"
                                  [value]="progress[file.name].progress | async"></mat-progress-bar>

            </mat-list-item>
        </mat-list>

        <div *ngIf="importMode == 'pickWorksheet' && (!fileImportStats || !fileImportStats.worksheets)">
            <h4>Invalid Sprout Excel Worksheet</h4>
        </div>
        <div *ngIf="importMode == 'pickWorksheet' && fileImportStats && fileImportStats.worksheets && fileImportStats.worksheets.length > 0">
            <mat-form-field >
                <mat-label>Pick Worksheet</mat-label>
                <mat-select [(ngModel)]="worksheetIndex">
                    <mat-option *ngFor="let worksheet of fileImportStats.worksheets" [value]="worksheet.index">
                        {{worksheet.name}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div *ngIf="importMode == 'nameForm' && fileImportStats && fileImportStats.worksheets && fileImportStats.worksheets.length > 0">
            <mat-form-field >
                <mat-label>Form Name</mat-label>
                <input matInput placeholder="Form Name" [(ngModel)]="formName"/>
                <mat-hint>Please give your form a name</mat-hint>
            </mat-form-field>
        </div>

        <div *ngIf="importMode == 'importForm'">
<!--            <h5>Importing form...</h5>-->
            <mat-progress-bar mode="determinate" value="50"></mat-progress-bar>
        </div>
    </mat-dialog-content>

    <!-- This are the actions of the dialog, containing the primary and the cancel button-->
    <mat-dialog-actions class="actions">
        <button *ngIf="showCancelButton" mat-button mat-dialog-close>Cancel</button>
        <!--        <button mat-raised-button color="primary" [disabled]="!canBeClosed || worksheetIndex < 0" (click)="runImport()">{{primaryButtonText}}</button>-->
        <button mat-raised-button color="primary" *ngIf="importMode == 'upload'" [disabled]="!files || files.size == 0"
                (click)="closeDialog()">Upload
        </button>
        <button mat-raised-button color="primary" *ngIf="importMode == 'pickWorksheet'" [disabled]="worksheetIndex < 0"
                (click)="nameForm()">Next
        </button>
        <button mat-raised-button color="primary" *ngIf="importMode == 'nameForm'" [disabled]="worksheetIndex < 0 && (!formName || formName.length == 0)"
                (click)="runImport()">Run Import
        </button>
        <button mat-raised-button color="primary" *ngIf="importMode == 'importForm'" (click)="closeDialog()">Finish
        </button>
    </mat-dialog-actions>
</div>